import { storeCreator } from '@/utils/store/store.utils';

interface SavePayoutDefinitionState {
  handleSave: (() => void) | null;
  isLoading: boolean;
  setHandleSave: (handler: (() => void) | null) => void;
  setIsLoading: (value: boolean) => void;
}

export const useSavePayoutDefinitionStore = storeCreator<SavePayoutDefinitionState>((set) => ({
  handleSave: null,
  isLoading: false,
  setHandleSave: (handler) => set({ handleSave: handler }),
  setIsLoading: (value) => set({ isLoading: value }),
}));
